import "./Manufacturing.module.css";
import Header from "@/reusable_sections/Header";
import Solutions from "./sections/Solutions";
import Manufacturing from "./sections/Manufacturing";
import Capacity from "./sections/Capacity";
import ProductionProcessRoadmap from "./sections/ProductionProcessRoadmap";
import Share from "./sections/Share";
import Footer from "@/reusable_sections/Footer";
export default function ManufacturingPage() {
  return <div>
      <Header />
      <Solutions />
      <Manufacturing />
      <ProductionProcessRoadmap />
      <Capacity />
      <Share />
      <Footer />
    </div>;
}